import { inject, Pipe, PipeTransform } from '@angular/core';
import { Permissions } from '@p2p/access-control/domain';
import { PermissionsFacade } from '@p2p/access-control/domain';
import { Observable } from 'rxjs';

@Pipe({
    name: 'permissions'
})
export class PermissionsPipe implements PipeTransform {
    private readonly permissionsFacade = inject(PermissionsFacade);

    transform(permissions: Permissions[]): Observable<boolean> {
        return this.permissionsFacade.hasPermissions(permissions);
    }
}
